/* eslint-disable react/no-unused-prop-types */
import * as React from 'react';
import { isEmpty } from 'lodash';

import InfluencerPosts from '../InfluencerPosts';

import { NUM_POSTS_VISIBLE } from 'utils/influencers';
import { t } from 'utils/language';

import type { Channel, InfluencerProfile, Post } from 'types';

type Props = {
  posts: Array<Post>,
  influencerProfile: InfluencerProfile,
  channel: Channel | undefined | null,
  channelType: string,
  count: number,
  numFollowers: number
};

class ChannelLatestPosts extends React.PureComponent<Props> {
  static defaultProps = {
    count: NUM_POSTS_VISIBLE.instagram
  };

  render(): React.ReactNode {
    const { posts, channelType, count, numFollowers } = this.props;

    if (isEmpty(posts)) {
      return null;
    }

    return (
      <div className="channel-latest-posts">
        <InfluencerPosts
          key={t(`influencer_recent_${channelType}_title`)}
          title={t(`influencer_recent_${channelType}_title`)}
          channelType={channelType}
          posts={posts}
          numImages={count}
          numFollowers={numFollowers}
        />
      </div>
    );
  }
}

export default ChannelLatestPosts;
